import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { utility } from '../common/utility';


@Injectable({
  providedIn: 'root'
})

export class NewsService {

  baseUrl: string;
  constructor(private http: HttpClient) {
  }
  public getAllNAINews(): Observable<any> {
    this.baseUrl = environment.apiBase.concat("News/GetAllNAINews");
      return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('getAllNAINews', [])));
  }

  public GetNewsMessage(id: any): Observable<any> {

    this.baseUrl = environment.apiBase.concat("News/GetNewsMessage?id=" + id);

      return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetNewsMessage', [])));
}

public RemoveNewsMessage(id: any): Observable<any> {

  this.baseUrl = environment.apiBase.concat("News/RemoveNewsMessage?id=" + id);

    return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('RemoveNewsMessage', [])));
}

public addNews(news: any): any {
  this.baseUrl = environment.apiBase.concat("News");
  let headers = new HttpHeaders();
  headers.append('Content-Type', 'application/json');
  return this.http.post(this.baseUrl, news, { headers: headers }).
      pipe(catchError(utility.handleError<any>('addNews', [])));
}

}
